/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateLayoutObjectResponse } from '../model'
// @ts-ignore
import type { DeleteLayoutObjectRequest } from '../model'
// @ts-ignore
import type { GateDirection } from '../model'
// @ts-ignore
import type { GetLayoutObjectsResponse } from '../model'
// @ts-ignore
import type { LayoutObjectType } from '../model'
// @ts-ignore
import type { UpdateLayoutObjectLayoutPositionRequest } from '../model'
// @ts-ignore
import type { UpdateLayoutObjectRequest } from '../model'
// @ts-ignore
import type { UpdateLayoutObjectResponse } from '../model'
/**
 * LayoutObjectsApi - axios parameter creator
 */
export const LayoutObjectsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} name
     * @param {number} width
     * @param {number} height
     * @param {LayoutObjectType} type
     * @param {number} [positionX]
     * @param {number} [positionY]
     * @param {number} [positionRotation]
     * @param {File} [image]
     * @param {string} [description]
     * @param {string} [color]
     * @param {number} [opacity]
     * @param {string} [code]
     * @param {GateDirection} [direction]
     * @param {boolean} [active]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLayoutObject: async (
      name: string,
      width: number,
      height: number,
      type: LayoutObjectType,
      positionX?: number,
      positionY?: number,
      positionRotation?: number,
      image?: File,
      description?: string,
      color?: string,
      opacity?: number,
      code?: string,
      direction?: GateDirection,
      active?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('createLayoutObject', 'name', name)
      // verify required parameter 'width' is not null or undefined
      assertParamExists('createLayoutObject', 'width', width)
      // verify required parameter 'height' is not null or undefined
      assertParamExists('createLayoutObject', 'height', height)
      // verify required parameter 'type' is not null or undefined
      assertParamExists('createLayoutObject', 'type', type)
      const localVarPath = `/yard/api/LayoutObjects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)()

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (name !== undefined) {
        localVarFormParams.append('Name', name as any)
      }

      if (positionX !== undefined) {
        localVarFormParams.append('Position.X', positionX as any)
      }

      if (positionY !== undefined) {
        localVarFormParams.append('Position.Y', positionY as any)
      }

      if (positionRotation !== undefined) {
        localVarFormParams.append('Position.Rotation', positionRotation as any)
      }

      if (width !== undefined) {
        localVarFormParams.append('Width', width as any)
      }

      if (height !== undefined) {
        localVarFormParams.append('Height', height as any)
      }

      if (type !== undefined) {
        localVarFormParams.append('Type', type as any)
      }

      if (image !== undefined) {
        localVarFormParams.append('Image', image as any)
      }

      if (description !== undefined) {
        localVarFormParams.append('Description', description as any)
      }

      if (color !== undefined) {
        localVarFormParams.append('Color', color as any)
      }

      if (opacity !== undefined) {
        localVarFormParams.append('Opacity', opacity as any)
      }

      if (code !== undefined) {
        localVarFormParams.append('Code', code as any)
      }

      if (direction !== undefined) {
        localVarFormParams.append('Direction', direction as any)
      }

      if (active !== undefined) {
        localVarFormParams.append('Active', String(active) as any)
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = localVarFormParams

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteLayoutObjectRequest} [deleteLayoutObjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLayoutObject: async (
      deleteLayoutObjectRequest?: DeleteLayoutObjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/LayoutObjects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteLayoutObjectRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLayoutObjectImage: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getLayoutObjectImage', 'id', id)
      const localVarPath = `/yard/api/LayoutObjects/{id}/Image`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<string>} [layoutObjectIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLayoutObjects: async (
      layoutObjectIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/LayoutObjects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (layoutObjectIds) {
        localVarQueryParameter['LayoutObjectIds'] = layoutObjectIds
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateLayoutObjectRequest} [updateLayoutObjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLayoutObject: async (
      updateLayoutObjectRequest?: UpdateLayoutObjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/LayoutObjects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateLayoutObjectRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateLayoutObjectLayoutPositionRequest} [updateLayoutObjectLayoutPositionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLayoutObjectLayoutPosition: async (
      updateLayoutObjectLayoutPositionRequest?: UpdateLayoutObjectLayoutPositionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/LayoutObjects/UpdateLayoutPosition`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateLayoutObjectLayoutPositionRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {File} image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadLayoutObjectImage: async (
      id: string,
      image: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('uploadLayoutObjectImage', 'id', id)
      // verify required parameter 'image' is not null or undefined
      assertParamExists('uploadLayoutObjectImage', 'image', image)
      const localVarPath = `/yard/api/LayoutObjects/{id}/Image`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)()

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (image !== undefined) {
        localVarFormParams.append('Image', image as any)
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = localVarFormParams

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LayoutObjectsApi - functional programming interface
 */
export const LayoutObjectsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LayoutObjectsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} name
     * @param {number} width
     * @param {number} height
     * @param {LayoutObjectType} type
     * @param {number} [positionX]
     * @param {number} [positionY]
     * @param {number} [positionRotation]
     * @param {File} [image]
     * @param {string} [description]
     * @param {string} [color]
     * @param {number} [opacity]
     * @param {string} [code]
     * @param {GateDirection} [direction]
     * @param {boolean} [active]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLayoutObject(
      name: string,
      width: number,
      height: number,
      type: LayoutObjectType,
      positionX?: number,
      positionY?: number,
      positionRotation?: number,
      image?: File,
      description?: string,
      color?: string,
      opacity?: number,
      code?: string,
      direction?: GateDirection,
      active?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLayoutObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createLayoutObject(
        name,
        width,
        height,
        type,
        positionX,
        positionY,
        positionRotation,
        image,
        description,
        color,
        opacity,
        code,
        direction,
        active,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LayoutObjectsApi.createLayoutObject']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteLayoutObjectRequest} [deleteLayoutObjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteLayoutObject(
      deleteLayoutObjectRequest?: DeleteLayoutObjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLayoutObject(
        deleteLayoutObjectRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LayoutObjectsApi.deleteLayoutObject']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLayoutObjectImage(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLayoutObjectImage(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LayoutObjectsApi.getLayoutObjectImage']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<string>} [layoutObjectIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLayoutObjects(
      layoutObjectIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLayoutObjectsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLayoutObjects(
        layoutObjectIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LayoutObjectsApi.getLayoutObjects']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateLayoutObjectRequest} [updateLayoutObjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLayoutObject(
      updateLayoutObjectRequest?: UpdateLayoutObjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLayoutObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateLayoutObject(
        updateLayoutObjectRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LayoutObjectsApi.updateLayoutObject']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateLayoutObjectLayoutPositionRequest} [updateLayoutObjectLayoutPositionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLayoutObjectLayoutPosition(
      updateLayoutObjectLayoutPositionRequest?: UpdateLayoutObjectLayoutPositionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateLayoutObjectLayoutPosition(
        updateLayoutObjectLayoutPositionRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LayoutObjectsApi.updateLayoutObjectLayoutPosition']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {File} image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadLayoutObjectImage(
      id: string,
      image: File,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLayoutObjectImage(
        id,
        image,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LayoutObjectsApi.uploadLayoutObjectImage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LayoutObjectsApi - factory interface
 */
export const LayoutObjectsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LayoutObjectsApiFp(configuration)
  return {
    /**
     *
     * @param {string} name
     * @param {number} width
     * @param {number} height
     * @param {LayoutObjectType} type
     * @param {number} [positionX]
     * @param {number} [positionY]
     * @param {number} [positionRotation]
     * @param {File} [image]
     * @param {string} [description]
     * @param {string} [color]
     * @param {number} [opacity]
     * @param {string} [code]
     * @param {GateDirection} [direction]
     * @param {boolean} [active]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLayoutObject(
      name: string,
      width: number,
      height: number,
      type: LayoutObjectType,
      positionX?: number,
      positionY?: number,
      positionRotation?: number,
      image?: File,
      description?: string,
      color?: string,
      opacity?: number,
      code?: string,
      direction?: GateDirection,
      active?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateLayoutObjectResponse> {
      return localVarFp
        .createLayoutObject(
          name,
          width,
          height,
          type,
          positionX,
          positionY,
          positionRotation,
          image,
          description,
          color,
          opacity,
          code,
          direction,
          active,
          options,
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteLayoutObjectRequest} [deleteLayoutObjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLayoutObject(
      deleteLayoutObjectRequest?: DeleteLayoutObjectRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteLayoutObject(deleteLayoutObjectRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLayoutObjectImage(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.getLayoutObjectImage(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<string>} [layoutObjectIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLayoutObjects(
      layoutObjectIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetLayoutObjectsResponse> {
      return localVarFp
        .getLayoutObjects(layoutObjectIds, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateLayoutObjectRequest} [updateLayoutObjectRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLayoutObject(
      updateLayoutObjectRequest?: UpdateLayoutObjectRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UpdateLayoutObjectResponse> {
      return localVarFp
        .updateLayoutObject(updateLayoutObjectRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateLayoutObjectLayoutPositionRequest} [updateLayoutObjectLayoutPositionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLayoutObjectLayoutPosition(
      updateLayoutObjectLayoutPositionRequest?: UpdateLayoutObjectLayoutPositionRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateLayoutObjectLayoutPosition(updateLayoutObjectLayoutPositionRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {File} image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadLayoutObjectImage(
      id: string,
      image: File,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .uploadLayoutObjectImage(id, image, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * LayoutObjectsApi - object-oriented interface
 */
export class LayoutObjectsApi extends BaseAPI {
  /**
   *
   * @param {string} name
   * @param {number} width
   * @param {number} height
   * @param {LayoutObjectType} type
   * @param {number} [positionX]
   * @param {number} [positionY]
   * @param {number} [positionRotation]
   * @param {File} [image]
   * @param {string} [description]
   * @param {string} [color]
   * @param {number} [opacity]
   * @param {string} [code]
   * @param {GateDirection} [direction]
   * @param {boolean} [active]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createLayoutObject(
    name: string,
    width: number,
    height: number,
    type: LayoutObjectType,
    positionX?: number,
    positionY?: number,
    positionRotation?: number,
    image?: File,
    description?: string,
    color?: string,
    opacity?: number,
    code?: string,
    direction?: GateDirection,
    active?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return LayoutObjectsApiFp(this.configuration)
      .createLayoutObject(
        name,
        width,
        height,
        type,
        positionX,
        positionY,
        positionRotation,
        image,
        description,
        color,
        opacity,
        code,
        direction,
        active,
        options,
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteLayoutObjectRequest} [deleteLayoutObjectRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteLayoutObject(
    deleteLayoutObjectRequest?: DeleteLayoutObjectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LayoutObjectsApiFp(this.configuration)
      .deleteLayoutObject(deleteLayoutObjectRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getLayoutObjectImage(id: string, options?: RawAxiosRequestConfig) {
    return LayoutObjectsApiFp(this.configuration)
      .getLayoutObjectImage(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<string>} [layoutObjectIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getLayoutObjects(layoutObjectIds?: Array<string>, options?: RawAxiosRequestConfig) {
    return LayoutObjectsApiFp(this.configuration)
      .getLayoutObjects(layoutObjectIds, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateLayoutObjectRequest} [updateLayoutObjectRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateLayoutObject(
    updateLayoutObjectRequest?: UpdateLayoutObjectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LayoutObjectsApiFp(this.configuration)
      .updateLayoutObject(updateLayoutObjectRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateLayoutObjectLayoutPositionRequest} [updateLayoutObjectLayoutPositionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateLayoutObjectLayoutPosition(
    updateLayoutObjectLayoutPositionRequest?: UpdateLayoutObjectLayoutPositionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LayoutObjectsApiFp(this.configuration)
      .updateLayoutObjectLayoutPosition(updateLayoutObjectLayoutPositionRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {File} image
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public uploadLayoutObjectImage(id: string, image: File, options?: RawAxiosRequestConfig) {
    return LayoutObjectsApiFp(this.configuration)
      .uploadLayoutObjectImage(id, image, options)
      .then(request => request(this.axios, this.basePath))
  }
}
